import $http from '@/api/index'

//选择位置tree
export function GetListLocationTree(id) {
	let options = {
		method: 'GET',
		url: 'basedata/GetListLocationTreeByCompanyExId',
		requestType: 2
	}
	let params = {
		companyExId: id,
		isContainCabinet: false
	}
	return $http(options, params)
}
//选择岗位tree
export function GetCompanyExDeptPost(id) {
	let options = {
		method: 'GET',
		url: 'basedata/GetCompanyExDeptPost',
		requestType: 2
	}
	let params = {
		userId: id,
		tag: ''
	}
	return $http(options, params)
}

//选择角色tree
export function GetListRoleTree(id) {
	let options = {
		method: 'GET',
		url: 'basedata/GetListRoleTree',
		requestType: 2
	}
	let params = {
		userId: id
	}
	return $http(options, params)
}

//选择联系人list
export function GetSAllLinkmanList(id) {
	let options = {
		method: 'GET',
		url: 'basedata/GetAllContactByCompanyExId',
		requestType: 2
	}
	let params = {
		companyExId: id
	}
	return $http(options, params)
}

//选择地址
export function GetDivisionCityCountryTown(id, name) {
	let options = {
		method: 'GET',
		url: 'basedata/GetDivisionCityCountryTown',
		requestType: 2
	}
	let params = {
		pid: id,
		keyword: name
	}
	return $http(options, params)
}

//行业分类
export function GetAllInductClassCodeTree(name, num) {
	let options = {
		method: 'GET',
		url: 'basedata/GetAllInductClassCodeTree',
		requestType: 2
	}
	let params = {
		keyword: name,
		tag: num
	}
	return $http(options, params)
}

//选择厂商、系列、型号、版本号
export function GetProductClassCodeTreeByDevTypeId(name) {
	let options = {
		method: 'GET',
		url: 'basedata/GetProductClassCodeTreeByDevTypeId',
		requestType: 2
	}
	let params = {
		devTypeId: name
	}
	return $http(options, params)
}
//选择所有运维对象实例
export function GetAllGeneralSelTree() {
	let options = {
		method: 'GET',
		url: 'basedata/GetAllGeneralSelTree',
		requestType: 2
	}
	let params = {

	}
	return $http(options, params)
}
//选择设备
export function GetDeviceProgObjectInfoByWay(code) {
	let options = {
		method: 'GET',
		url: 'basedata/GetDeviceProgObjectInfoByWay',
		requestType: 2
	}
	let params = {
		tagDeviceOrProg: 1,
		tagLocOrClsOrDept: 1,
		companyGeneralCode: code,
		deviceTypeCode: ''
	}
	return $http(options, params)
}
//g根据MAC获取设备信息
export function getMac(mac) {
	let options = {
		method: 'GET',
		url: 'user/GetHost',
		requestType: 2
	}
	let params = {
		mac: mac
	}
	return $http(options, params)
}
//根据主机编号获取设备信息
export function GetHostBySerialno(serialno) {
	let options = {
		method: 'GET',
		url: 'basedata/GetHostBySerialno',
		requestType: 2
	}
	let params = {
		serialno: serialno
	}
	return $http(options, params)
}
//根据mac获取usb
export function GetLocalUsbSimpleInfo(target,root) {
	let options = {
		method: 'GET',
		url: 'im/GetLocalUsbSimpleInfo',
		requestType: 2
	}
	let params = {
		target: target,
		root:root
	}
	return $http(options, params)
}
//根据任务ID获取端口申请
export function GetDeviceApplyInfoById(Id) {
	let options = {
		method: 'GET',
		url: 'USB/GetDeviceApplyInfoById',
		requestType: 2
	}
	let params = {
		Id: Id
	}
	return $http(options, params)
}
//根据任务ID获取U盘申请
export function GetPortApplyRecordById(Id) {
	let options = {
		method: 'GET',
		url: 'USB/GetPortApplyRecordById',
		requestType: 2
	}
	let params = {
		Id: Id
	}
	return $http(options, params)
}
//添加USB申请
export function AddUsbDeviceApplyInfo(formData) {
	let options = {
		method: 'post',
		url: 'USB/AddUsbDeviceApplyInfo',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}
//添加U端口申请
export function AddPortApplyInfo(formData) {
	let options = {
		method: 'post',
		url: 'USB/AddPortApplyInfo',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}
//審核端口申请
export function AuditPortApplyInfo(formData) {
	let options = {
		method: 'post',
		url: 'USB/AuditPortApplyInfo',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}
//審核U盤申请
export function AuditUsbDeviceApplyInfo(formData) {
	let options = {
		method: 'post',
		url: 'USB/AuditUsbDeviceApplyInfo',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}
//获取客户机类型和设备信息
export function GetHostPolicyInfoByMac(mac) {
	let options = {
		method: 'GET',
		url: 'USB/GetHostPolicyInfoByMac',
		requestType: 2
	}
	let params = {
		hostMac: mac
	}
	return $http(options, params)
}
//获取是否需要发送验证
export function GetConfig(config) {
	let options = {
		method: 'GET',
		url: 'DMS/GetConfig',
		requestType: 2
	}
	let params = {
		config: config
	}
	return $http(options, params)
}
//获取验证结果
export function VerifyUserByCode(code,pws) {
	let options = {
		method: 'GET',
		url: 'user/VerifyUserByCode',
		requestType: 2
	}
	let params = {
		code: code,
		pws:pws
	}
	return $http(options, params)
}
//U盤授权
export function EntrustHostPolicyInfo(formData) {
	let options = {
		method: 'post',
		url: 'USB/EntrustHostPolicyInfo',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}
//获取所有U盘
export function GetAllUsbSimpleInfoList() {
	let options = {
		method: 'GET',
		url: 'USB/GetAllUsbSimpleInfoList',
		requestType: 2
	}
	let params = {}
	return $http(options, params)
}
//U盘获取已授权客户机
export function GetHostListByUsbDeviceid(usbdeviceid) {
	let options = {
		method: 'GET',
		url: 'USB/GetHostListByUsbDeviceid',
		requestType: 2
	}
	let params = {
		usbdeviceid: usbdeviceid
	}
	return $http(options, params)
}
//U盘获取已授权客户机以及权限
export function GetHostHasPolicyListByUsbDeviceid(usbdeviceid) {
	let options = {
		method: 'GET',
		url: 'USB/GetHostHasPolicyListByUsbDeviceid',
		requestType: 2
	}
	let params = {
		usbdeviceid: usbdeviceid
	}
	return $http(options, params)
}
//删除u盘
export function DeleteDeviceInfoById(usbdeviceid) {
	let options = {
		method: 'POST',
		url: 'USB/DeleteDeviceInfoById?usbdeviceid=' + usbdeviceid,
		requestType: 2
	}
	let params = {}
	return $http(options, params)
}
//完全删除u盘
export function FullDeleteDeviceInfoById(usbdeviceid) {
	let options = {
		method: 'POST',
		url: 'USB/FullDeleteDeviceInfoById?usbdeviceid=' + usbdeviceid,
		requestType: 2
	}
	let params = {}
	return $http(options, params)
}
//获取删除u盘
export function GetAllDeleteUsbSimleInfoList() {
	let options = {
		method: 'GET',
		url: 'USB/GetAllDeleteUsbSimleInfoList',
		requestType: 2
	}
	let params = {}
	return $http(options, params)
}
//运维人员u盘授权
export function addUsbDeviceAllApply(formData) {
	let options = {
		method: 'post',
		url: 'USB/addUsbDeviceAllApply',
		requestType: 2,
		isFormData: true
	}
	return $http(options, formData)
}

function trim(str) {
	return str.replace(/^(\s|\u00A0)+/, '').replace(/(\s|\u00A0)+$/, '');
}
//正则表达式
export function regular(parameter, str) {
	//	$.trim(str.toString());
	str = trim(str.toString())
	console.log(str)
	var reg, r;
	switch(parameter) {
		case 'number': //纯数字
			reg = /^[0-9]*$/
			r = reg.test(str) ? true : '请输入数字值'
			break;
		case 'email': //QQ邮箱
			reg = /^\d{5,12}@[qQ][qQ]\.(com|cn)$/
			r = reg.test(str) ? true : '请输入正确邮箱'
			break;
		case 'phone': //手机号
			reg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/
			r = reg.test(str) ? true : '请输入正确手机号'
			break;
		case 'telephone': //电话
			reg = /\d{3}-\d{8}|\d{4}-\d{7}/
			r = reg.test(str) ? true : '请输入正确电话号码'
			break;
		case 'chinese': //汉字
			reg = /^[\u4e00-\u9fa5]{0,}$/
			r = reg.test(str) ? true : '请输入汉字'
			break;
		case 'english': //全英文
			reg = /^[A-Za-z]+$/
			r = reg.test(str) ? true : '请输入英文'
			break;
		case 'IDnumber ': //身份证号码
			reg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/
			r = reg.test(str) ? true : '请输入正确身份证号码'
			break;
	}
	return r
}

//export function listToTree(myId, pId, list) { //将数组转化为树形结构
//
//	function exists(list, parentId) {
//		//如果他有父亲的话就把他添加到nodes列表里
//		for(var i = 0; i < list.length; i++) {
//			if(list[i][myId] == parentId) return true;
//		}
//		return false;
//	};
//	var nodes = [];
//	for(var i = 0; i < list.length; i++) {
//		var row = list[i];
//		if(!exists(list, row[pId])) {
//			nodes.push(row);
//		}
//	}
//	//des为第一级别
//	var toDo = [];
//	for(var i = 0; i < nodes.length; i++) {
//		toDo.push(nodes[i]);
//	};
//	//toDo = nodes
//	while(toDo.length) {
//		var node = toDo.shift(); // the parent node
//		for(var i = 0; i < list.length; i++) {
//			var row = list[i];
//			if(row[pId] == node[myId]) {
//				if(node.children) {
//					node.children.push(row);
//				} else {
//					node.children = [row];
//				}
//				toDo.push(row);
//			}
//		}
//	}
//	return nodes; //树形菜单
//}
export function listToTree(myId, pId, list) {
	const dic = new Map();
	const dic_1 = new Map();
	var len = list.length;
	for(var i = 0; i < len; i++) {
		dic.set(list[i][myId], list[i]);
		if(dic_1.has(list[i][pId])) {
			dic_1.get(list[i][pId]).push(list[i]);
		} else {
			dic_1.set(list[i][pId], [list[i]]);
		}
	}
	var nodes = [];
	for(var i = 0; i < len; i++) {
		if(!dic.has(list[i][pId])) {
			nodes.push(list[i]);
		}
	}
	var toDo = [];
	var len_1 = nodes.length;
	for(var i = 0; i < len_1; i++) {
		toDo.push(nodes[i]);
	};
	while(toDo.length) {
		var node = toDo.shift(); // the parent node
		if(dic_1.has(node[myId])) {
			var ls = dic_1.get(node[myId]);
			node.children = ls; //dic_1.get(node[myId]);
			for(var j = 0; j < ls.length; j++)
				toDo.push(ls[j]);
		}
	}
	return nodes; //树形菜单
}